import React, { createContext, useEffect, useState } from 'react';

import useAuth from 'hooks/useAuth';
import { chatAPI } from 'services/api';

type FeatureFlagsContextType = {
  features: string[];
  hasFeature: (feature: string) => boolean;
};

const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
  features: [],
  hasFeature: () => false,
});

export const FeatureFlagsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const auth = useAuth();
  const [features, setFeatures] = useState<string[]>([]);

  useEffect(() => {
    if (auth.loading || !auth.currentUser) {
      return;
    }

    const getFeatures = async () => {
      try {
        const res = await chatAPI.get('v2/tenants/feature-flags');
        setFeatures(res.data || []);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erro ao carregar feature flags:', error);
        setFeatures([]);
      }
    };

    getFeatures();
  }, [auth.loading, auth.currentUser]);

  const hasFeature = (feature: string) => features.includes(feature);

  return (
    <FeatureFlagsContext.Provider value={{ features, hasFeature }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsContext;
